@use "../../style/variables" as *;
@use "../../style/mixins" as *;

.container {
  cursor: pointer;
  display: flex;
  width: 100%;
  margin-bottom: .5rem;

  @include mobile {
    margin-bottom: 1rem;
  }
}

.dark {
  .label {
    color: $grey-text-light;
    font-size: .85rem;
    font-weight: 300;

    & a {
      color: $grey-text-light;
    }
  }

  .checkbox {
    &:checked {
      & ~ .label {
        color: $grey;

        & a {
          color: $grey;
        }
      }

      & + label {
        border: 2px solid $ny-red;
      }
    }

    & + label {
      border: 2px solid $grey-text-light;
      background-color: $white;

      width: 1rem;
      height: 1rem;
      padding: 0;
    }
  }
}

.checkbox {
  &:checked {
    & + label {
      border: 2px solid $white;
    }

    & ~ .label {
      color: white;

      & a {
        color: white;
      }
    }
  }
}

.label {
  cursor: pointer;
  display: inline;
  color: $grey-light;
  font-size: .85rem;
  font-weight: 300;
  line-height: 1.125rem;

  & a {
    color: $grey-light;
  }


  @include mobile {
    top: 0;
  }

}

.checkbox {
  display: none;
  width: 0;
  height: 0;

  & + label {
    cursor: pointer;
    border: 2px solid $grey-text-light;
    background-color: transparent;
    padding: .3rem;
    border-radius: 20%;
    position: relative;
    vertical-align: text-bottom;
    margin-right: .5rem;
    width: 0;
    height: 0;
  }
}

.dark {
  .checkbox {
    &:checked {
      & + label {
        &:after {
          content: '';
          width: 100%;
          height: 100%;
          display: block;
          background: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj4gICAgICAgICAgICAgICAgPHBhdGggICAgICAgICAgICAgICAgICAgIGQ9Ik0xNzMuODk4IDQzOS40MDRsLTE2Ni40LTE2Ni40Yy05Ljk5Ny05Ljk5Ny05Ljk5Ny0yNi4yMDYgMC0zNi4yMDRsMzYuMjAzLTM2LjIwNGM5Ljk5Ny05Ljk5OCAyNi4yMDctOS45OTggMzYuMjA0IDBMMTkyIDMxMi42OSA0MzIuMDk1IDcyLjU5NmM5Ljk5Ny05Ljk5NyAyNi4yMDctOS45OTcgMzYuMjA0IDBsMzYuMjAzIDM2LjIwNGM5Ljk5NyA5Ljk5NyA5Ljk5NyAyNi4yMDYgMCAzNi4yMDRsLTI5NC40IDI5NC40MDFjLTkuOTk4IDkuOTk3LTI2LjIwNyA5Ljk5Ny0zNi4yMDQtLjAwMXoiIGZpbGw9IndoaXRlIi8+PC9zdmc+") no-repeat center;
          font-size: 2rem;
          position: absolute;
          bottom: 0;
          left: 0;
        }

        &:before {
          background: $ny-red;
        }
      }
    }
  }
}

.checkbox {
  &:checked {
    & + label {
      border-color: $ny-red;

      &:after {
        content: '';
        width: 100%;
        height: 100%;
        display: block;
        background: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiBmaWxsPSJ3aGl0ZSI+ICAgICAgICAgICAgICAgIDxwYXRoICAgICAgICAgICAgICAgICAgICBkPSJNMTczLjg5OCA0MzkuNDA0bC0xNjYuNC0xNjYuNGMtOS45OTctOS45OTctOS45OTctMjYuMjA2IDAtMzYuMjA0bDM2LjIwMy0zNi4yMDRjOS45OTctOS45OTggMjYuMjA3LTkuOTk4IDM2LjIwNCAwTDE5MiAzMTIuNjkgNDMyLjA5NSA3Mi41OTZjOS45OTctOS45OTcgMjYuMjA7LTkuOTk3IDM2LjIwNCAwbDM2LjIwMyAzNi4yMDRjOS45OTcgOS45OTcgOS45OTcgMjYuMjA2IDAgMzYuMjA0bC0yOTQuNCAyOTQuNDAxYy05Ljk5OCA5Ljk5Ny0yNi4yMDcgOS45OTctMzYuMjA0LS4wMDF6Ii8+PC9zdmc+") no-repeat center;
        font-size: 2rem;
        position: absolute;
        bottom: 0;
        left: 0;
      }

      &:before {
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
      }
    }
  }
}